import { h } from "preact";
import { NavLink } from "react-router-dom";

import { classNames } from "../helpers";

export default function SecondaryNaviItem({ children, to, ...props }) {
  let Tag = "span";
  if (to) {
    Tag = NavLink;
    props = {
      ...props,
      to,
      className: ({ isActive }) =>
        [
          "secondary-navi__item waves-effect waves-light",
          isActive ? "secondary-navi__item--active" : "",
          props.class,
        ].join(" "),
    };
  } else {
    props = {
      ...props,
      className: classNames(
        "secondary-navi__item",
        "waves-effect",
        "waves-light",
        props.class
      ),
    };
  }

  return (
    <Tag role="menuitem" exact {...props}>
      <span>{children}</span>
    </Tag>
  );
}
